'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import {
  KAKAO_MOMENT_PIXEL_ID,
  trackKakaoPixelEvent,
} from '@/utils/analytics/kakao-pixel';

const PageViewEventLoggerContent = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    trackKakaoPixelEvent(KAKAO_MOMENT_PIXEL_ID, 'pageView');
  }, [pathname, searchParams]);

  return null;
};

export const PageViewEventLogger = () => {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense>
        <PageViewEventLoggerContent />
      </Suspense>
    </ErrorBoundary>
  );
};
